module.exports = __webpack_public_path__ + "static/media/earth_spin_mask_2.b849f206.mp4";